/* eslint-disable max-statements */
import React, { Component } from 'react';
// import { AppSettings } from '../../constants';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import 'rsuite/dist/styles/rsuite-default.css';
import { Timeline } from 'rsuite';
import {DateFilterDashboard} from 'components/date-filter-dashboard/index';
import {Link} from 'react-router-dom';
import Panel from 'react-bootstrap/lib/Panel';
import { cloneDeep, isEmpty } from 'lodash';
import Moment from 'moment';
import moment from 'moment-timezone';
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';
class LatestActivities extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    DashBoardStore: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object,
    LatestActivitiesList: PropTypes.array,
    loading: PropTypes.bool,
    isLoadingMore: PropTypes.bool,
    getFilterLatestActivities: PropTypes.func,
    FilterLatestActivitiesList: PropTypes.array,
    hasMoreData: PropTypes.bool,
    isLoadingMoreFilter: PropTypes.bool,
    LatestActivitiesScrollDown: PropTypes.array,
    getLatestActivitiesScrollDown: PropTypes.func
  };

  static contextTypes = {
    t: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.initialStartDate = moment
      .utc().subtract(24, 'hours')
      .local()
      .format();
    this.initialFromDate = moment
      .utc()
      .local()
      .format();
    this.state = {
      startDate: this.initialStartDate,
      endDate: this.initialFromDate,
      numberOfActivities: 20,
      isLoading: this.props.loading,
      filterData: this.props.FilterLatestActivitiesList
    };
  }

  componentDidMount() {
    let data = {
      take: this.state.numberOfActivities,
      sorts: [
        {
          sortField: 'createdDate',
          sortOrder: 1
        }
      ],
      from: this.state.startDate,
      to: this.state.endDate
    };

    this.props.getFilterLatestActivities({
      data
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.FilterLatestActivitiesList !== nextProps.FilterLatestActivitiesList) {
      this.setState({
        filterData: nextProps.FilterLatestActivitiesList
      });
    }

    if (this.props.LatestActivitiesScrollDown !== nextProps.LatestActivitiesScrollDown) {
      this.setState({
        filterData: [...this.state.filterData, ...nextProps.LatestActivitiesScrollDown]
      });
    }

    if (this.props.loading !== nextProps.loading) {
      this.setState({
        isLoading: nextProps.loading
      });
    }
  }

  componentWillUnmount() {
    this.setState({
      isLoading: false,
      filterData: []
    });
  }

  renderNameTimeLine = (item) => {
    if (item.woRefNo) {
      return 'WO#';
    }

    if (item.requestType === 0 || item.requestType === 2 || item.requestType === 3) {
      return 'RFS#';
    }

    if (item.requestType === 1) {
      return 'BT#';
    }
    return '';
  }

  customRouterLink = (customName, id, workOrderId, requestType) => {
    if (customName === 'WO#') {
      return ([0,2,3].includes(requestType))
        ? `/request-for-services/work-order/detail/${id}/${workOrderId}`
        : `punch-lists/${id}/punch-list-item/${workOrderId}`;
    }

    if (customName === 'RFS#') {
      return `/request-for-services/${id}`;
    }

    if (customName === 'BT#') {
      return `/punch-lists/${id}`;
    }
    return '';
  }

  renderActionDescription = (item) => {
    if (item.action === 1) {
      return 'created this work order.';
    } //WOCreation
    if (item.action === 2) {
      return 'edited this work order.';
    } //WOModification
    if (item.comment) {
      return `commented: "${item.comment}"`;
    }
    if (item.action === 3) {
      //WOStatusChanged
      const statusField = item.changedFields.find(
        field => field.fieldName === 'Status'
      );
      const newStatus = statusField ? (
        <span style={{ fontStyle: 'italic' }}>{statusField.newValue}</span>
      ) : (
        ''
      );

      if (statusField && statusField.newValue === 'Resolved') {
        const lastResolvedDate = item.changedFields.find(
          field => field.fieldName === 'LastResolvedDate'
        );

        const homeownerSignature = item.changedFields.find(
          field => field.fieldName === 'HomeOwnerSignature'
        );

        return (
          <span>
            changed status to {newStatus}.
            {lastResolvedDate &&
              ` Last resolved date was updated to ${Moment(
                lastResolvedDate.newValue
              ).format('MM/DD/YYYY')}.`}
            {homeownerSignature && ' Homeowner signature was captured.'}
          </span>
        );
      }

      if (statusField && statusField.newValue === 'Closed') {
        const lastClosedDate = item.changedFields.find(
          field => field.fieldName === 'LastClosedDate'
        );
        const lastResolvedDate = item.changedFields.find(
          field => field.fieldName === 'LastResolvedDate'
        );
        const closedReason = item.changedFields.find(
          field => field.fieldName === 'ClosedReason'
        );

        const homeownerSignature = item.changedFields.find(
          field => field.fieldName === 'HomeOwnerSignature'
        );

        return (

          <span>
            changed status to {newStatus}.
            {lastResolvedDate &&
              ` Last resolved date was updated to ${Moment(
                lastResolvedDate.newValue
              ).format('MM/DD/YYYY')}.`}
            {lastClosedDate &&
              ` Last closed date was updated to ${Moment(
                lastClosedDate.newValue
              ).format('MM/DD/YYYY')}.`}
            {homeownerSignature && ' Homeowner signature was captured.'}
            {closedReason && ` Reason was \"${closedReason.newValue}\".`}
          </span>
        );
      }

      if (statusField && statusField.newValue === 'Declined') {
        const DeclinedReason = item.changedFields.find(
          field => field.fieldName === 'DeclinedReason'
        );
        return (
          <span>
            changed status to {newStatus}.
            {DeclinedReason && ` Reason was \"${DeclinedReason.newValue}\".`}
          </span>
        );
      }

      if (statusField && statusField.newValue === 'Requested to reopen') {
        const reopenReason = item.changedFields.find(
          field => field.fieldName === 'ReopenReason'
        ).newValue;
        return (
          <span>
            changed status to {newStatus}. Reason was "{reopenReason}."
          </span>
        );
      }

      if (
        statusField &&
        statusField.newValue === 'Pending' &&
        statusField.oldValue === 'Open'
      ) {
        const holdReason = item.changedFields.find(
          field => field.fieldName === 'HoldReason'
        ).newValue;
        return (
          <span>
            changed status to {newStatus}. Reason was "{holdReason}."
          </span>
        );
      }

      return <span>changed status to {newStatus}.</span>;
    }
    if (item.action === 4) {
      //WOSendToAssignee
      const assignee = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      return `sent this work order to ${assignee}.`;
    }
    if (item.action === 5) {
      //WOResendToAssignee
      const assignee = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      return `resent this work order to ${assignee}.`;
    }
    if (item.action === 6) {
      //WOUploadAttachment
      const fileName = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      return `uploaded ${fileName}.`;
    }

    if (item.action === 9) {
      //autoGeneratePDFAttachment
      const fileName = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      return `${fileName} was automatically uploaded after the homeowner's signature is captured.`;
    }

    if (item.action === 20) {
      //POCreation
      const poRefNo = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      return `created PO#${poRefNo}.`;
    }
    if (item.action === 21) {
      //POSendToAssignee
      const poRefNo = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      const assignee = item.changedFields[1]
        ? item.changedFields[1].newValue
        : '';
      return `sent PO#${poRefNo} to ${assignee}.`;
    }
    if (item.action === 22) {
      //POResendToAssignee
      const poRefNo = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      const assignee = item.changedFields[1]
        ? item.changedFields[1].newValue
        : '';
      return `resent PO#${poRefNo} to ${assignee}.`;
    }
    if (item.action === 30) {
      //BCCreation
      const bcRefNo = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      const poRefNo = item.changedFields[1]
        ? item.changedFields[1].newValue
        : '';
      return `created BC#${bcRefNo} for PO#${poRefNo}.`;
    }
    if (item.action === 31) {
      //BCSendToAssignee
      const bcRefNo = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      const assignee = item.changedFields[1]
        ? item.changedFields[1].newValue
        : '';
      return `sent BC#${bcRefNo} to ${assignee}.`;
    }
    if (item.action === 40) {
      //RFSCreation
      return 'created this request.';
    }
    if (item.action === 41) {
      //RFSModification
      return 'edited this request.';
    }

    return '(Not specified)';
  };

  renderCustomTerms = key => {
    const { t } = this.context;
    if (t) {
      return t(key);
    }
    return key;
  };

  renderAutomat = (item, timelineIndex) => {
    return (
      <Timeline.Item className={timelineIndex === 0 ? 'rs-timeline-item-first' : ''}>
        <div className='history-record clearfix'>
          <div className='history-content'>
            <span className='automat'>
            Status was automatically updated to "Closed" since the creator
            failed to close it.
            </span>
            <span style={{color: 'lightgray', marginLeft: 15}} className='date'>
              {Moment(item.createdDate).format('MM/DD/YYYY hh:mm A')}
            </span>
          </div>
        </div>
      </Timeline.Item>
    );
  };

  renderWOAutomaticallyOpen = (item, timelineIndex) => {
    return (
      <Timeline.Item className={timelineIndex === 0 ? 'rs-timeline-item-first' : ''}>
        <div className='history-record clearfix'>
          <div className='history-content'>
            <span className='automat'>{item.actionDescription}</span>
            <span style={{color: 'lightgray', marginLeft: 15}} className='date'>
              {Moment(item.createdDate).format('MM/DD/YYYY hh:mm A')}
            </span>
          </div>
        </div>
      </Timeline.Item>
    );
  };

  renderWOAutomaticallyAssignEvent = (item, timelineIndex) => {
    const assignEvent = JSON.parse(item.changedFields[0].newValue);
    const numFunction = () => {
      let numEvent = assignEvent.Order;
      if (numEvent === 2) {
        return 'nd';
      } else if (numEvent === 3) {
        return 'rd';
      } else {
        return 'th';
      }
    };
    const num = numFunction();
    const emailEvent = assignEvent.Emails.join(',  ');
    return (
      <Timeline.Item className={timelineIndex === 0 ? 'rs-timeline-item-first' : ''}>
        <div className= 'history-record clearfix'>
          <div className='history-content'>
            <span style={{wordBreak: 'break-word'}} className='automat'>{`The ${assignEvent.Order}${num} follow up notice was sent to ${emailEvent}`}</span>
            <span style={{color: 'lightgray', marginLeft: 15}} className='date'>
              {Moment(item.createdDate).format('MM/DD/YYYY hh:mm A')}
            </span>
          </div>
        </div>
      </Timeline.Item>
    );
  }

  renderRFSAutomat = (item, timelineIndex) => {
    const assignEvent = JSON.parse(item.changedFields[0].newValue);
    // const numEvent = assignEvent.Order;
    const numFunction = () => {
      let numEvent = assignEvent.Order;
      if (numEvent === 1) {
        return 'st';
      } else if (numEvent === 2) {
        return 'nd';
      } else if (numEvent === 3) {
        return 'rd';
      } else {
        return 'th';
      }
    };
    const num = numFunction();
    const emailEvent = assignEvent.Emails.join(',  ');
    return (
      <Timeline.Item className={timelineIndex === 0 ? 'rs-timeline-item-first' : ''}>
        <div className= 'history-record clearfix'>
          <div className='history-content'>
            <span style={{wordBreak: 'break-word'}} className='automat'>{`The ${assignEvent.Order}${num} follow up notice was sent to ${emailEvent}`}</span>
            <span style={{color: 'lightgray', marginLeft: 15}} className='date'>
              {Moment(item.createdDate).format('MM/DD/YYYY hh:mm A')}
            </span>
          </div>
        </div>
      </Timeline.Item>
    );
  };

  renderOldNewValue = (fieldName, value) => {
    if (fieldName === 'AppointmentDate') {
      if (value === '' || value === null) {
        return <span style={{opacity: 0.5}}>(Not specified)</span>;
      } else {
        return Moment(value).format('MM/DD/YYYY hh:mm A');
      }
    } else if (
      fieldName === 'LastResolvedDate' ||
      fieldName === 'LastClosedDate'
    ) {
      if (value === '' || value === null) {
        return <span style={{opacity: 0.5}}>(Not specified)</span>;
      } else {
        return Moment(value).format('MM/DD/YYYY');
      }
    } else {
      return value;
    }
  };

  renderSubActivities = (item, timelineIndex) => {
    if (item.action === 10) {
      //WOAutomaticallyClosed
      return this.renderAutomat(item, timelineIndex);
    }

    if (item.action === 7) {
      //WOAutomaticallyOpen
      return this.renderWOAutomaticallyOpen(item, timelineIndex);
    }
    if (item.action === 11) {
      return this.renderWOAutomaticallyAssignEvent(item, timelineIndex);
    }
    if (item.action === 45) {
      return this.renderRFSAutomat(item, timelineIndex);
    }
    if (item.action === 2 || item.action === 41) {
      return (
        <Timeline.Item key={timelineIndex} className={timelineIndex === 0 ? 'rs-timeline-item-first' : ''}>
          <div className='show-edit-information-dashboard history-record clearfix'>
            <Panel eventKey='1'>
              <Panel.Heading>
                <Panel.Title toggle>
                  <div className='history-content'>
                    <span className='username'>{item.actor}</span>
                    <span style={{marginLeft: 5}} className='action'>
                      {this.renderActionDescription(item)}
                    </span>
                    <i style={{float: 'none', marginLeft: 5, marginTop: 0, marginRight: 0}} className='caret' />
                    <span style={{color: 'lightgray', marginLeft: 15}} className='date'>
                      {Moment(item.createdDate).format('MM/DD/YYYY [at] hh:mm A')}
                    </span>
                  </div>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                {item.changedFields.map((field, index) => (
                  <div key={index} className='updated-detail'>
                    <div className='updated-field'>
                      {this.renderCustomTerms(field.fieldName)}
                    </div>
                    <div className='updated-content'>
                      <ul>
                        <li key='old-value'>
                          <span className='updated-header'>Old value: </span>
                          {this.renderOldNewValue(
                            field.fieldName,
                            field.oldValue
                          ) !== null ? <span>
                              {this.renderOldNewValue(
                                field.fieldName,
                                field.oldValue
                              )}
                            </span> : <span style={{opacity: 0.5}}>(Not specified)</span>}
                        </li>
                        <li key='new-value'>
                          <span className='updated-header'>New value: </span>
                          {this.renderOldNewValue(
                            field.fieldName,
                            field.newValue
                          ) !== null ? <span>
                              {this.renderOldNewValue(
                                field.fieldName,
                                field.newValue
                              )}
                            </span> : <span style={{opacity: 0.5}}>(Not specified)</span>}
                        </li>
                      </ul>
                    </div>
                  </div>
                ))}
              </Panel.Body>
            </Panel>
          </div>
        </Timeline.Item>
      );
    }

    return (
      <Timeline.Item className={timelineIndex === 0 ? 'rs-timeline-item-first' : ''}>
        <div className='history-record clearfix'>
          <div className='history-content'>
            <span className='username'>{item.actor}</span>
            <span style={{marginLeft: 5}} className='action'>
              {this.renderActionDescription(item)}
            </span>
            <span style={{color: 'lightgray', marginLeft: 15}} className='date'>
              {Moment(item.createdDate).format('MM/DD/YYYY [at] hh:mm A')}
            </span>
          </div>
        </div>
      </Timeline.Item>
    );
  }

  showItems(item, index) {
    const customName = this.renderNameTimeLine(item);
    return (
      <div key={index} className=' row time-line-information' key ={index}>
        <div className='col-xs-12 col-md-3 col-sm-4 timeline-title'>
          <Link to={this.customRouterLink(customName, item.refNo, item.woRefNo, item.requestType)}>
            <label style={{marginLeft: 20, cursor: 'pointer'}}>{customName}{item.woRefNo !== null ? item.woRefNo : item.refNo}</label>
          </Link>
        </div>
        <div className='col-xs-12 col-md-9 col-sm-8 timeline-content'>
          <Timeline>
            {item.activities.map((el, activityIndex) => this.renderSubActivities(el, activityIndex))}
          </Timeline>
        </div>
      </div>
    );
  }

  //FIXME: THIS IS FOR RENDER ALL DATA
  // loadMore = () => {
  //   const {isLoadingMore} = this.props;
  //   if (isLoadingMore) {
  //     return;
  //   }
  //   this.renderMoreItems();
  // }

  loadMoreFilter = () => {
    const {isLoadingMoreFilter} = this.props;
    if (isLoadingMoreFilter) {
      return;
    }
    this.renderMoreFilterItems();
  }

  onSaveFilterDateRange = () => (fromDate, toDate) => {
    if (fromDate && toDate) {
      let data = {
        take: this.state.numberOfActivities,
        sorts: [
          {
            sortField: 'createdDate',
            sortOrder: 1
          }
        ],
        from: fromDate,
        to: toDate
      };
      this.setState({
        filterData: [],
        startDate: fromDate,
        endDate: toDate
      }, () => {
        this.props.getFilterLatestActivities({data});
      });
    }

  };

  renderMoreFilterItems = () => {
    let cloneData = [...this.state.filterData];
    let lastDate;
    let listSinceDate = cloneData.map(x => x.activities.slice(-1)[0]);
    const sortListSinceDate = listSinceDate.sort(this.compareDataToGetSinceDate);
    lastDate = sortListSinceDate.slice(-1)[0].createdDate;

    if (lastDate) {
      let data = {
        take: this.state.numberOfActivities,
        sorts: [
          {
            sortField: 'createdDate',
            sortOrder: 1
          }
        ],
        from: this.state.startDate,
        to: this.state.endDate,
        since: lastDate
      };
      this.props.getLatestActivitiesScrollDown({data});
    }
  }

  onCheckDuplicateFilterData = (filterData) => {
    const dataMap = cloneDeep(filterData).reduce((result, item) => {
      if (result[item.woRefNo]) {
        result[item.woRefNo].activities = [...result[item.woRefNo].activities, ...item.activities];
        return result;
      }
      if (!item.woRefNo) {
        if (result[item.refNo]) {
          result[item.refNo].activities = [...result[item.refNo].activities, ...item.activities];
          return result;
        }
        result[item.refNo] = item;
        return result;
      }
      result[item.woRefNo] = item;
      return result;
    }, {});
    return Object.values(dataMap);
  }

  compareData = (a, b) => {
    const typeA = a.activities.map(x => x.createdDate);
    const typeB = b.activities.map(x => x.createdDate);

    if (typeA > typeB) {return -1;}

    if (typeB > typeA) {return 1;}

    return 0;
  }

  compareDataToGetSinceDate = (a , b) => {
    const typeA = a.createdDate;
    const typeB = b.createdDate;

    if (typeA > typeB) {return -1;}

    if (typeB > typeA) {return 1;}

    return 0;
  }

  renderLatestActivities = () => {
    const {filterData } = this.state;
    //FIXME: THIS IS FOR RENDER ALL DATA
    // const dataCheckDuplicate = this.onCheckDuplicateData(data);
    const dataFilterCheckDuplicate = this.onCheckDuplicateFilterData(filterData);
    const dataFilterAfterSort = dataFilterCheckDuplicate.sort(this.compareData);
    // let activitiesCount = ((filterData.map(x => x.activities.length).reduce((a, b) => a + b, 0)));
    // console.log(dataFilterCheckDuplicate, 'dataFilterCheckDuplicate');
    return (
      <div className='new-request-from-homeowner box-form-siteone clearfix'>
        <div className='row latest-activities-title'>
          <div className='col-sm-5 col-md-5 col-lg-6 latest-activities-label'>
            <h4>Latest Activities</h4>
          </div>
          <div className='col-sm-7 col-md-7 col-lg-6 latest-activities-filter'>
            <DateFilterDashboard
              ref={c => {
                this.dateFilterDashBoard = c;
              }}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onSave={this.onSaveFilterDateRange('filterData')}
            />
          </div>
        </div>
        <div style={isEmpty(filterData) || filterData === null ? {textAlign: 'center'} : {}} className='col-xs-12 col-md-12 latest-activities-timeline'>
          {isEmpty(filterData) || filterData === null ? <span>There is no data to display</span>
            : <InfiniteScroll
              loadMore={this.loadMoreFilter}
              hasMore={this.props.hasMoreData}
              loader={<div className='spinner-load-dashboard'><i onClick={this.renderMoreItems} className='fa fa-spin fa-spinner loading-ic' /></div>}
              useWindow={false}
            >
              {dataFilterAfterSort.map((item, index) => this.showItems(item, index))}{' '}
            </InfiniteScroll>}
        </div>{' '}
      </div>
    );

    //FIXME: THIS IS FOR RENDER ALL DATA
    // return (
    //   <div className='new-request-from-homeowner box-form-siteone clearfix'>
    //     <div className='row latest-activities-title'>
    //       <div className='col-xs-5 col-md-6 latest-activities-label'>
    //         <h4>Latest Activities</h4>
    //       </div>
    //       <div className='col-xs-7 col-md-6 latest-activities-filter'>
    //         <DateFilterDashboard
    //           ref={c => {
    //             this.dateFilterDashBoard = c;
    //           }}
    //           startDate={this.state.startDate}
    //           endDate={this.state.endDate}
    //           onSave={this.onSaveFilterDateRange('filterData')}
    //         />
    //       </div>
    //     </div>
    //     <div className='col-xs-12 col-md-12 latest-activities-timeline'>
    //       <InfiniteScroll
    //         loadMore={this.loadMore}
    //         hasMore={this.props.hasMoreActivities}
    //         loader={<div className='spinner-load-dashboard'><i onClick={this.renderMoreItems} className='fa fa-spin fa-spinner loading-ic' /></div>}
    //         useWindow={false}
    //       >
    //         {dataCheckDuplicate.map((item, index) => this.showItems(item, index))}{' '}
    //       </InfiniteScroll>{' '}
    //     </div>{' '}
    //   </div>
    // );
  }

  renderSkeleton = () => {
    return (
      <SkeletonTheme color='#efe6e6'>
        <Skeleton count={1} style={{ height: 770, margin: '10px 0px 0px'}} />
      </SkeletonTheme>
    );
  }

  render() {
    const {isLoading} = this.state;
    return (
      <React.Fragment>
        {isLoading === false ? this.renderSkeleton() : this.renderLatestActivities()}
      </React.Fragment>
    );
  }
}

export default LatestActivities;



// WEBPACK FOOTER //
// ./src/Dashboard/Components/latest-activities.js